import angular from 'angular'
import { ReactRegisterOpenCloseComponent } from '../pages/RegisterOpenClose'
import { QuickKeysSettingsComponent } from '../pages/QuickKeysSettings'
import { SettingsComponent } from '../pages/Settings'
import { DuplicateWindowComponent } from '../pages/DuplicateWindow'
import { StatusViewComponent } from './status/StatusView'
import { TrackingProvider } from './tracking/tracking.service'

// Sale
import { SaleInventoryData as SaleInventoryDataService } from './sale/sale-inventory-data/sale-inventory-data.service'
import { MarkUnfulfilledModalService } from './react/modals/mark-as-unfulfilled-modal/mark-unfulfilled-modal.service'
import { QuoteCustomerModalService } from './react/modals/quote-customer-modal/quote-customer-modal-service'
import { ServiceModalService } from './react/modals/service-modal/service-modal.service'
import { AccountBalanceSetupModalService } from './sale/account-balance-setup-modal/account-balance-setup-modal.service'
import { ErroredSalesModalController } from './sale/errored-sales-modal/errored-sales-modal.controller'
import { RetrieveSalePopoverController } from './sale/retrieve-sale/retrieve-sale-popover/retrieve-sale-popover.controller'
import { OutletsDifferModalController } from './sale/outlets-differ-modal/outlets-differ-modal.controller'
import { MarkUnfulfilledModalController } from './react/modals/mark-as-unfulfilled-modal/mark-unfulfilled-modal.controller'
import { QuoteCustomerModalController } from './react/modals/quote-customer-modal/quote-customer-modal.controller'
import { ServiceModalController } from './react/modals/service-modal/service-modal.controller'
import { ServiceSaleRefundModalController } from './react/modals/service-sale-refund-modal/service-sale-refund-modal.controller'
import { AccountBalanceSetupModalController } from './sale/account-balance-setup-modal/account-balance-setup-modal.controller'

// React Components
// -- Sale
import { MarkAsUnfulfilledModalComponent } from './react/modals/mark-as-unfulfilled-modal/MarkAsUnfulfilledModal'
import { QuoteCustomerModalComponent } from './react/modals/quote-customer-modal/QuoteCustomerModal'
import { ServiceModalComponent } from './react/modals/service-modal/ServiceModal'
import { ServiceSaleRefundModalComponent } from './react/modals/service-sale-refund-modal/ServiceSaleRefundModal'
import { AccountBalanceSetupModalComponent } from './sale/account-balance-setup-modal/AccountBalanceSetupModal'
// -- Shared
import { wrToastNotifications } from './react/helios/ToastNotifications/WrToastNotifications'
// -- Promotion
import { vbPromotionModal } from './promotions/promotion-modal/PromotionModalWrapper'

// Sale Confirmation
import { ReceiptSelectionPopoverController } from './receipts/receipt-selection-popover/receipt-selection-popover.controller'
import { ReceiptPrintSelectedComponent } from './receipts/receipt-print-selected/receipt-print-selected.component'
import { QuotePrintComponent } from './receipts/quote-print/quote-print.component'

// Shared
import { PreloadReceiptImagesComponent } from './shared/preload-receipt-images/preload-receipt-images.component'
import { NoPermissionsPageComponent } from './react/react-utilities/NoPermissionsPage'
import './react'

// Register
import './register/registers-resource/registers-resource'

// Select Register Modal
import { SelectRegisterModalComponent } from './select-register/selectRegisterModal'

// Cash Management
import { CashManagementViewComponent } from './cash-management/CashManagementView'

// Gift Cards
import './gift-cards/gift-cards-resource/gift-cards-resource'

// Route Management
import './route-management/route-management'

// Payments
import './payments/payments'

// Customer
import './customer/customer'

// Product
import './product/product'

// Restricted Access
import './restricted-access/restricted-access'
import { wrNoProductsModal } from './restricted-access/NoProductsModal'

// Promotion
import './promotions/promotions-resource/promotions-resource'
import { PromotionModalService } from './promotions/promotion-modal/promotion-modal.service'
import { PromotionModalController } from './promotions/promotion-modal/promotion-modal.controller'

// Sales
import './sale/sales-resource/sales-resource'

// Search
import './search/search-resource/search-resource'

// User Switching
import './users/user-switching/user-switching'

// Service Worker Manager
import './service-worker/service-worker-manager/service-worker-manager'

// Barcode service
import './sale/barcode/barcode'

// Sale Versioning Manager
import './sale/sale-versioning-manager/sale-versioning-manager'

// Hot Keys
import './hotkeys/hotkeys'

// Workflows
import './workflows/workflows'

// Sale Tracker
import './sale/sale-tracker/sale-tracker'

// Cash Movement Receipt
import './receipts/cash-movement-receipt/CashMovementReceipt'

// Store Credit Issue Receipt
import './receipts/store-credit-issue-receipt/StoreCreditIssueReceipt'

import { ServiceSaleRefundModalService } from './react/modals/service-sale-refund-modal/service-sale-refund-modal.service'
import { OfflinePage } from './offline/Offline'
import { ReactSummaryPanel } from './sale/summary-panel/SummaryPanel'
import { ReactPaymentPanel } from './sale/payment-panel/PaymentPanel'
import { WorkSpaceComponent } from './workspace/Workspace'
import { ReactConfirmationPanel } from './sale/confirmation-panel/ConfirmationPanel'
import { ReactSaleRootComponent } from './sale/Sale'
import { ReactLoadingSkeleton } from './loading-skeleton/LoadingSkeleton'
import { ReactTranslateTitle } from './helpers/TranslateTitle'
import { ReactRealtimeEventHandlerComponent } from './realtime-provider/realtime-event-handler'

import { ReactTrainingTour } from './training/TrainingTour'
import { ReactRegisterActionsComponent } from './register/register-actions/RegisterActions'
import { ReactPrintContainerComponent } from './print/PrintContainer'

angular
  .module('webregister.components')

  .provider('tracking', TrackingProvider)

  .service('saleInventoryData', SaleInventoryDataService)
  .service('markUnfulfilledModalService', MarkUnfulfilledModalService)
  .service('quoteCustomerModalService', QuoteCustomerModalService)
  .service('serviceModalService', ServiceModalService)
  .service('serviceSaleRefundModalService', ServiceSaleRefundModalService)
  .service('accountBalanceSetupModalService', AccountBalanceSetupModalService)
  .service('promotionModalService', PromotionModalService)

  .component('reactLoadingSkeleton', ReactLoadingSkeleton)
  .component('translateTitle', ReactTranslateTitle)
  .component('preloadReceiptImages', PreloadReceiptImagesComponent)
  .component('reactPrintContainer', ReactPrintContainerComponent)
  .component('cashManagementView', CashManagementViewComponent)
  .component('wrNoProductsModal', wrNoProductsModal)
  .component('reactSaleRootComponent', ReactSaleRootComponent)
  .component('reactSummaryPanel', ReactSummaryPanel)
  .component('reactTrainingTour', ReactTrainingTour)
  .component('reactRegisterActions', ReactRegisterActionsComponent)
  .component('reactPaymentPanel', ReactPaymentPanel)
  .component('reactConfirmationPanel', ReactConfirmationPanel)
  .component('reactRegisterOpenClose', ReactRegisterOpenCloseComponent)
  .component('quickKeysSettings', QuickKeysSettingsComponent)
  .component('reactDuplicateWindow', DuplicateWindowComponent)
  .component('settings', SettingsComponent)
  .component('reactWorkspaceComponent', WorkSpaceComponent)
  .component('receiptPrintSelected', ReceiptPrintSelectedComponent)
  .component('quotePrint', QuotePrintComponent)

  .component('markAsUnfulfilledModal', MarkAsUnfulfilledModalComponent)
  .component('quoteCustomerModal', QuoteCustomerModalComponent)
  .component('serviceModal', ServiceModalComponent)
  .component('serviceSaleRefundModal', ServiceSaleRefundModalComponent)
  .component('accountBalanceSetupModal', AccountBalanceSetupModalComponent)
  .component('vbPromotionModal', vbPromotionModal)
  .component('wrToastNotifications', wrToastNotifications)
  .component('selectRegisterModal', SelectRegisterModalComponent)
  .component('noPermissionsPage', NoPermissionsPageComponent)
  .component('statusView', StatusViewComponent)
  .component('offlinePage', OfflinePage)
  .component('reactRealtimeEventHandler', ReactRealtimeEventHandlerComponent)

angular
  .module('webregister.controllers')
  .controller('ErroredSalesModalController', ErroredSalesModalController)
  .controller('RetrieveSalePopoverController', RetrieveSalePopoverController)
  .controller('OutletsDifferModalController', OutletsDifferModalController)
  .controller(
    'ReceiptSelectionPopoverController',
    ReceiptSelectionPopoverController
  )
  .controller('quoteCustomerModalController', QuoteCustomerModalController)
  .controller('serviceModalController', ServiceModalController)
  .controller(
    'serviceSaleRefundModalController',
    ServiceSaleRefundModalController
  )
  .controller('markUnfulfilledModalController', MarkUnfulfilledModalController)
  .controller(
    'accountBalanceSetupModalController',
    AccountBalanceSetupModalController
  )
  .controller('promotionModalController', PromotionModalController)
